export const COVER_WIDTH = 788;
export const COVER_HEIGHT = 258;
export const COVER_RESOLUTION = `${COVER_WIDTH}x${COVER_HEIGHT}`;
